import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {BroverDefaultComponentModule} from '../brover-default-component/brover-default-component.module';
import {BroverMaterialModule} from '../brover-material/brover.material.module';
import {PlaceOrderComponent} from './pages/place-order/place-order.component';
import {OrderHistoryComponent} from './pages/order-history/order-history.component';
import {QuickOrderComponent} from './pages/quick-order/quick-order.component';
import {TendersComponent} from './pages/tenders/tenders.component';
import {OrderStatisticsComponent} from './pages/order-statistics/order-statistics.component';
import {ConfigurateComponent} from './pages/place-order/configurate/configurate.component';
import {ArticleService} from './services/article.service';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {CdkTableModule} from '@angular/cdk/table';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import {BroverRouterModule} from '../brover-router/brover.router.module';
import { ThanksPageComponent } from './pages/thanks-page/thanks-page.component';
import {ShoppingService} from './services/shopping.service';
import {CompanyService} from './services/company.service';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { MatNativeDateModule } from '@angular/material/core';
import {FilterService} from './services/filter.service';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { ProfileComponent } from './pages/profile/profile.component';
import { provideLottieOptions, LottieComponent } from 'ngx-lottie';
import player from 'lottie-web';
import { SaveOrderDialogComponent } from './pages/place-order/save-order-dialog/save-order-dialog.component';
import { OrderService } from './services/order.service';
import { TenderService } from './services/tender.service';
import { DeliveryAdresDialogComponent } from './pages/order-statistics/delivery-adres-dialog/delivery-adres-dialog.component';
import { MAT_DIALOG_DATA as MAT_DIALOG_DATA, MatDialogRef as MatDialogRef } from '@angular/material/dialog';
import { AddComponent } from './pages/order-statistics/delivery-adres-dialog/add/add.component';
export function playerFactory() {
  return player;
}

@NgModule({ declarations: [
        PlaceOrderComponent,
        OrderHistoryComponent,
        QuickOrderComponent,
        TendersComponent,
        OrderStatisticsComponent,
        ConfigurateComponent,
        ThanksPageComponent,
        DashboardComponent,
        ProfileComponent,
        SaveOrderDialogComponent,
        DeliveryAdresDialogComponent,
        AddComponent,
    ], imports: [CommonModule,
        BroverDefaultComponentModule,
        BroverMaterialModule,
        BroverRouterModule,
        BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        MatNativeDateModule,
        FormsModule,
        ReactiveFormsModule,
        CdkTableModule,
        LottieComponent], providers: [ArticleService, ShoppingService, CompanyService, FilterService, OrderService, TenderService, { provide: MAT_DIALOG_DATA, useValue: {} }, { provide: MatDialogRef, useValue: {} }, provideHttpClient(withInterceptorsFromDi()), provideLottieOptions({ player: playerFactory })] })
export class ComponentModule { }
